import { Stack, UnstyledButton } from "@mantine/core";
import { SimpleFullScreenPageWithAppBarAndTitle } from "components/pages/pages_with_outlet/SimpleFullScreenPageWithAppBarAndTitle";
import { OSCE } from "navigation/Paths";
import { useNavigate } from "react-router-dom";

export const RatingInstruments = () => {
  const navigate = useNavigate();
  return (
    <SimpleFullScreenPageWithAppBarAndTitle
      title="Rating Instruments"
      order={4}
    >
      <Stack>
        <UnstyledButton onClick={() => navigate(OSCE)}>OSCE</UnstyledButton>
      </Stack>
    </SimpleFullScreenPageWithAppBarAndTitle>
  );
};
